import { cameraApiRequest } from './cameraApiRequest';

/**
 * A camera's stills of a day (YYYY-MM-DD, Europe/Helsinki), oldest first:
 * `{ date, stills }`, each with a signed `thumbnailUrl` and `url` (about 10
 * minutes). The API logs VIEW_CAMERA_RECORDING once per day opened. Needs
 * `cameras_view_recordings`.
 */
export const getCameraStills = ({
  projectId,
  cameraId,
  date,
  activeEmployerInfo,
}) =>
  cameraApiRequest({
    method: 'GET',
    apiPath: `projects/${projectId}/cameras/${cameraId}/stills?date=${encodeURIComponent(
      date
    )}`,
    activeEmployerInfo,
  });
